<template>
  <div>
    <div class="bg-icon__wrapper">
      <svg
        class="bg-icon"
        width="699px"
        height="699px"
        viewBox="0 0 699 699"
        fill="none"
      >
        <path
          d="M698.383 241.704H457.266V0.587463L241.705 0.587463V241.704H0.587402L0.587402 457.267H241.705V698.384H457.266L457.266 457.267L698.383 457.267V241.704Z"
          fill="#303AB2"
          fill-opacity="0.05"
        />
      </svg>
    </div>
    <div class="flex">
      <MyAccountWrapper />
      <div class="profile">
        <div class="profile__content !max-w-[750px]">
          <div class="profile__profileWrapper">
            <div class="flex flex-col items-center justify-center gap-5">
              <p class="profile-title">
                {{ $t("settings.preferences.subtitle") }}
              </p>
              <p
                class="text-sm font-medium text-left w-full text-secondary-400 dark:text-greyscale-500"
              >
                {{ $t("settings.preferences.description") }}
              </p>
            </div>
            <div class="preferences-description">
              <div>
                <p class="text-greyscale-600 dark:text-secondary-300">
                  {{ $t("settings.preferences.dark_mode.subtitle") }}
                </p>
                <p
                  class="text-greyscale-500 dark:text-greyscale-500 whitespace-nowrap"
                >
                  {{ $t("settings.preferences.dark_mode.description") }}
                </p>
              </div>
              <Select
                class="!w-[160px]"
                v-model="selectedTheme"
                :options="themeOptions"
                :key="count"
              >
              </Select>
            </div>
            <div class="preferences-description">
              <div>
                <p class="text-greyscale-600 dark:text-secondary-300">
                  {{ $t("settings.preferences.pref_language.subtitle") }}
                </p>
                <p
                  class="text-greyscale-500 dark:text-greyscale-500 whitespace-nowrap"
                >
                  {{ $t("settings.preferences.pref_language.description") }}
                </p>
              </div>
              <Select
                class="!w-[160px]"
                v-model="selectedLanguage"
                :options="languageOptions"
              >
              </Select>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyAccountWrapper from "@/components/MyAccountWrapper";
import Select from "@/components/Select";
import { THEMES, PREF_LANG } from "@/constants";
import { mapActions, mapGetters } from "vuex";
import { i18n } from "@/plugins/i18n";

export default {
  name: "Preferences",
  components: {
    MyAccountWrapper,
    Select,
  },
  data() {
    return {
      selectedTheme: localStorage.getItem("theme") || "system",
      selectedLanguage: localStorage.getItem("pref_lang") || "en",
      count: 0,
    };
  },
  computed: {
    ...mapGetters(["getTheme"]),
    themeOptions() {
      let types = THEMES.THEME;
      types.map((item) => {
        item.text = this.$t(item.text_theme);
        return item;
      });
      return types;
    },
    languageOptions() {
      let types = PREF_LANG.LANGUAGES;
      types.map((item) => {
        item.text = this.$t(item.text_lang);
        return item;
      });
      return types;
    },
  },
  methods: {
    ...mapActions(["initTheme"]),
  },
  watch: {
    selectedTheme(newTheme) {
      this.$store.dispatch("initTheme", newTheme);
    },
    selectedLanguage(newLanguage) {
      i18n.locale = newLanguage;
      localStorage.setItem("pref_lang", newLanguage);
      this.count = this.count + 1;
    },
  },
};
</script>
<style lang="css" scoped>
@import url("index.module.css");
</style>
